module.exports = __webpack_public_path__ + "img/DK28299494.fb123205.png";